import styled from 'styled-components';

export const DropZoneWrapper = styled.div`
  min-height: 218px;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  border: 1.5px dashed #a9c7e9;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  padding: 16px;
`;

export const Image = styled.img`
  width: 50px;
  display: block;
  margin: 0 auto 8px;
`;

export const BtnsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
